export default {
  // banner列表
  bannerList: [
    {
      img: require('@/assets/images/banner_01.jpg'),
      name: 'banner1'
      // link: 'http://www.baidu.com' // 有链接加,外链要记得加http
    },
    {
      img: require('@/assets/images/banner_02.jpg'),
      name: 'banner2'
    }
  ],
  // 光模块器件
  brandList: [
    {
      img: require('@/assets/images/rider.png'),
      name: '射频及微波',
      detail: '面向卫星通讯、高速数据链、以及各种射频通讯系统提供相关关键模拟以及数字技术的控制设备及模块。公司产品可覆盖微波传输设备、雷达、短波超短波通信、广播设备等各行业应用。'
    },
    {
      img: require('@/assets/images/basestation.jpg'),
      name: '天线产品',
      detail: '公司面向车载通讯、卫星通信、数据通信等应用领域提供不同种类的天线产品。包括4G/5G天线，GPS天线，各种无线通讯接收机天线。提供终端天线定制服务，包括：GPS天线、组合天线、低频天线、定位精密测量天线、WIFI天线、5G/4G天线等。'
    },
    {
      img: require('@/assets/images/datacenter.jpg'),
      name: '高性能计算',
      detail: '包括面向高性能数据运算应用的边缘计算盒子、高性能加速卡产品以及中小型信息化加密系统设计，具有将相关设计产品的IP进行ASIC化的能力，具有面向高性能工业数据计算的系统集成能力。'
    },
    {
      img: require('@/assets/images/cnc1.jpg'),
      name: '机械加工设计',
      detail: '我们提供面向高端工业和射频天线应用的机械加工设计和产品，包括模具设计和产品铸造加工设计。同时我们也提供基于客户特殊需求而定制的各类相关领域的设计服务和产品。'
    }
  ],
  // 核心价值
  coreValuesList: [
    {
      img: require('@/assets/images/coreValues/technologybimg3.jpg'),
      name: '客户至上',
      id: 0,
      type: 1,
      detail: '坚持以客户和市场需求为驱动，紧密把握市场动向，及时响应服务客户，服务好客户。',
      html: [
        '客户需求是我们发展的原动力；我们坚持以客户为中心，快速响应客户需求，持续为客户创造长期价值进而成就客户；为客户提供有效服务，是我们工作的方向和价值评价的标尺，成就客户就是成就我们自己。',
        {
          img: require('@/assets/images/coreValues/technologybimg3.jpg')
        },
        '市场拓展并不像销售产品那么简单，我们急客户所急、想客户所想，尽可能地满足客户的需求。',
        '在面对客户时没有对错之分，只有客户满意的才是正确的。即使严格按照公司规章制度和流程体系完成了工作，如果没达到客户满意的程度，就不能算成功，更谈不上正确。也就是说，客户永远是正确的。',
        '<a href="/user/test/xxxx.pdf" download="Case1.pdf"  style="color: #1e50ae;text-align:center;display: block;"> >>>>>>>>>>某智能驾驶客户天线产品及机械铸造案例<<<<<<<<<< </a>'
      ]
    },
    {
      img: require('@/assets/images/coreValues/technologybimg5.jpg'),
      name: '诚信为本',
      id: 1,
      type: 1,
      detail: '诚信是推动企业生产力提高的精神动力！',
      html: [
        {
          img: require('@/assets/images/coreValues/technologybimg4.jpg')
        },
        '企业凝聚力是企业生命力和企业活力的重要标志，而企业诚信则是增强企业凝聚力的源泉。一方面，企业对内以诚信作为核心价值观，成为大家认同和遵从的价值规范，有助于把各级员工对企业的朴素情感升华为强烈的责任心和自豪感，把敬业爱岗的自发意识转化为员工的自觉行动，使每位个体的积极性凝聚为一个整体，从而增强企业的生命力和活力。',
        '企业的生存与发展是以经济利益的最大化为目标，而真正持久的经济效益来自于诚信经营。在客户关系管理中只有以诚信服务为前提，才能切实保证企业与广大客户进行深入的交流，增进彼此的了解和认知，建立符合彼此要求的诚信服务体系，真正赢得客户。',
        '<a href="/user/test/xxxx.pdf" download="Case1.pdf"  style="color: #1e50ae;text-align:center;display: block;"> >>>>>>>>>>某高性能加速计算板卡成功案例<<<<<<<<<< </a>'
      ]
    },
    {
      img: require('@/assets/images/coreValues/technologybimg1.jpg'),
      name: '团队合作',
      id: 2,
      type: 1,
      detail: '所有坤恒人积极融入团队，乐意接受同事的帮助，配合团队完成工作；',
      html: [
        {
          img: require('@/assets/images/coreValues/technologybimg1.jpg')
        },
        '决策前积极发表建设性意见，充分参与团队讨论，决策后，无论个人是否有异议，必 须从言行上完全予以支持；积极主动分享业务知识和经验；主动给予同事必要的帮助；善于利用团队的力量解决 问题和困难；善于和不同类型的同事合作，不将个人喜好带入工作，充分体现“对事不对人”的原则；有主人翁意识，积极正面地影响团队，改善团队氛围！',
        '<a href="/user/test/xxxx.pdf" download="Case1.pdf"  style="color: #1e50ae;text-align:center;display: block;"> >>>>>>>>>>某接收机整体项目案例<<<<<<<<<< </a>'
      ]
    },
    {
      img: require('@/assets/images/coreValues/technologybimg2.jpg'),
      name: '成功案例',
      id: 3,
      type: 1,
      detail: '坚持技术专业、市场专注、服务专心是我们不变的承诺！',
      html: [
        {
          img: require('@/assets/images/coreValues/technologybimg2.jpg')
        },
        '典型行业成功案例解析：',
        '<a href="/user/test/xxxx.pdf" download="Case1.pdf"  style="color: #1e50ae;text-align:center;display: block;"> >>>>>>>>>>某图像采集系统边缘计算案例<<<<<<<<<< </a>',
        '<a href="/user/test/xxxx.pdf" download="Case2.pdf"  style="color: #1e50ae;text-align:center;display: block;"> >>>>>>>>>>某FPGA加速卡的加密处理案例<<<<<<<<<< </a>',
        '<a href="/user/test/xxxx.pdf" download="Case3.pdf"  style="color: #1e50ae;text-align:center;display: block;"> >>>>>>>>>>某视频传输系统天线定制案例<<<<<<<<<< </a>',
        '部分设备展示：',
        {
          img: require('@/assets/images/coreValues/equip1.png')
        },
        {
          img: require('@/assets/images/coreValues/equip2.png')
        },
        {
          img: require('@/assets/images/coreValues/equip3.png')
        },
        {
          img: require('@/assets/images/coreValues/equip4.png')
        }
      ]
    }
  ],
  // 热销主题列表
  businessList: [
    {
      name: '产品和技术服务',
      list: [
        {
          label: '智能负载识别器',
          type: 0,
          id: 0
        },
        {
          label: 'IMX8MQ核心板',
          type: 2,
          id: 0
        },
        {
          label: '产品设计定制服务',
          type: 4
        }
      ]
    },
    {
      name: '国际品牌元件',
      list: [
        {
          label: 'Broadcom LSI SAS 9560'
        },
        {
          label: 'FCI 61082/61083系列连接器'
        },
        {
          label: 'TI LM2596系列电源芯片'
        }
      ]
    },
    {
      name: '本土品牌元件',
      list: [
        {
          label: 'HCI 晶振/钟振'
        },
        {
          label: '高可靠性线束设计生产'
        },
        {
          label: '至誉SSD工业级固态存储盘'
        }
      ]
    }
  ],
  // 推荐
  recommend: [
    {
      id: 17,
      name: '2026年CPO能否实现大规模量产？',
      img: require('@/assets/images/news/news_33.png')
    },
    {
      id: 16,
      name: '2026年800G以上光收发模块占比将突破60%',
      img: require('@/assets/images/news/news_29.png')
    }
  ],
  // 公司相关信息
  company: {
    name: '坤恒科技发展有限公司',
    title: 'Kun Heng Technology Development Co, Ltd.',
    detail: '坤恒科技 --- Kun Heng Technology，',
    html: [
      '我们是专业射频系统及高速通信系统方案服务厂商，核心人才来自国内外一流学府及研究机构，均具有丰富的行业经验。',
      '坤恒深圳生产支持中心坐落在我国生产和供应链最为发达的广东，负责投产全系列射频和通信板卡产品以供应市场和服务客户。',
      '我们坚持服务客户和市场的发展路线，积极参与行业技术创新，严格质量控制和管理供应链，以期与您长期共同成长发展！',
      '➣2016年成立北京研发中心，面向射频及天线应用领域。',
      '➣2017年通信板卡系列产品顺利验收。',
      '➣2019年机械加工产品中心落成。',
      '➣2023年加速向AI融合计算转型。',
      {
        img: require('@/assets/images/aboutMe/company_news04.jpg')
      },
      '➣2020年全系列FPGA加速卡产品顺利发布！',
      '➣2021年公司扩充产品支持团队，全面承接各类定制化项目及系统集成项目。',
      '➣2024年公司发布国产化AI GPU卡。',
      {
        img: require('@/assets/images/aboutMe/company_news06.jpg')
      },
      '➣2022年公司搬迁至北京市新总部 - 石景山中海时代广场。',
      '➣总部地址： 北京市石景山区阜石路与北辛安路交叉口中海时代广场B座808',
      '➣联系电话： 010-69879833 *',
      '➣电子邮件： info@kun-heng.com'
    ]
  },
  // 合作伙伴
  partnerList: [
    {
      name: 'EDNChina',
      img: require('@/assets/images/partner_logo_01.png'),
      link: 'https://www.ednchina.com/'
    },
    {
      name: 'CSDN社区',
      img: require('@/assets/images/partner_logo_02.png'),
      link: 'https://www.csdn.net/?spm=1001.2101.3001.4476/'
    },
    {
      name: '无线论坛',
      img: require('@/assets/images/partner_logo_03.png'),
      link: 'https://https://www.anywlan.com/'
    },
    {
      name: '电子工程专辑',
      img: require('@/assets/images/partner_logo_04.png'),
      link: 'https://www.eet-china.com/'
    },
    {
      name: 'RFID世界',
      img: require('@/assets/images/partner_logo_05.gif'),
      link: 'http://www.rfidworld.com.cn/'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/datas/index.js